import { cardHeaderClasses, typographyClasses, type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "../../../definitions/components.types"
import { simpleWidgetCardClasses } from "../../../themeTypes"

export const createSimpleWidgetCardTheme = (theme: Theme): SimpleWidgetCardTheme => ({
    styleOverrides: {
        card: {
            gap: theme.spacing(1.5),
        },
        header: {
            [`.${cardHeaderClasses.content}`]: {
                [`.${typographyClasses.root}`]: {
                    fontSize: "1.5rem",
                },
            },
        },
    },
    variants: [
        {
            props: { widgetVariant: "startpage" },
            style: {
                padding: ".5em .75em",
                [`.${simpleWidgetCardClasses.card}`]: {
                    boxShadow: "none",
                    paddingTop: ".75em",
                    padding: "1em",
                    borderLeft: "4px solid rgba(0,0,0,.15)",
                    "&:hover": {
                        backgroundColor: "#fafafa",
                        border: "1px solid #0085ca",
                        borderLeft: "4px solid #0085ca",
                    },
                },
                [`.${simpleWidgetCardClasses.header}`]: {
                    padding: 0,
                    [`>.${cardHeaderClasses.action}`]: {
                        marginRight: -8,
                    },
                },
                [`.${simpleWidgetCardClasses.content}`]: {
                    padding: 0,
                    "&:last-child": {
                        paddingBottom: 0,
                    },
                },
            },
        },
        {
            props: { widgetVariant: "dashboard" },
            style: {
                [`.${simpleWidgetCardClasses.card}, .${simpleWidgetCardClasses.cover}`]: {
                    backgroundColor: "#fafafa",
                    "&:hover": {
                        borderColor: "#0085ca",
                    },
                    [`.${simpleWidgetCardClasses.actions}`]: {
                        padding: "0 1em 1em",
                    },
                },
            },
        },
    ],
})
